import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import WidgetIntro from './WidgetIntro';
import $ from 'jquery';
import WidgetSettings from './WidgetSettings';

class WidgetSettingsTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/projectmgmt/look-and-feel";
      var path1 = window.origin + "/platform/projectmgmt/look-and-feel/";

      var widgetThemeSubTabs = ["/look-and-feel/title-logo", "/look-and-feel/launcher-icon",
        "/look-and-feel/widget-logo", "/look-and-feel/change-font"];

      var isWidgetThemeSubTab = false;
      for (var i = 0; i < widgetThemeSubTabs.length; i++) {
        if (currentPath.includes(widgetThemeSubTabs[i])) {
          isWidgetThemeSubTab = true;
          break;
        }
      }

      if (currentPath === path || currentPath === path1 || isWidgetThemeSubTab) {
        $("#widget-theme").addClass('active');
      } else if (currentPath.includes("/projectmgmt/look-and-feel/widget-label")) {
        $("#widget-label").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#widget-theme,#widget-label")
        .on("click", function () {
          $("#widget-theme,#widget-label")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })
    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB", marginLeft: '-10px' }}>

            <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
            <title> Dheeyantra | Clusters Details</title>
            {/* Font Awesome Icons */}
            <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
            {/* IonIcons */}
            <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            {/* Theme style */}
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />

            <div className="container-fluid" style={{ marginLeft: '10px' }}>
              {/* Nav tabs */}
              <div className="tab-class" >
                <ul className="nav nav-tabs border-bottom navCluster">
                  <Link to="/projectmgmt/look-and-feel" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="widget-theme">Widget Theme</li>
                  </Link>
                  <Link to="/projectmgmt/look-and-feel/widget-label" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="widget-label">Widget Label</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <Switch>
            <Route path="/projectmgmt/look-and-feel/widget-label" component={WidgetIntro}></Route>
            <Route path="/projectmgmt/look-and-feel" component={WidgetSettings}></Route>
          </Switch>
        </div>
      </Router>

    );
  }
}
export default WidgetSettingsTab;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/WidgetSettingsTab.js